import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUp } from "lucide-react";

const SCROLL_THRESHOLD = 700;

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > SCROLL_THRESHOLD);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => {
    if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.2 });
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          initial={{ opacity: 0, y: 16, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 12, scale: 0.9 }}
          transition={{ duration: 0.25 }}
          data-testid="back-to-top"
          aria-label="Torna in cima alla pagina"
          onClick={toTop}
          className="fixed bottom-[76px] right-5 z-[85] flex h-9 w-9 items-center justify-center rounded-full border border-[#c9a45c]/50 bg-[#0d0d0d]/90 text-gold shadow-[0_12px_28px_rgba(0,0,0,0.55)] backdrop-blur-xl transition-colors duration-300 hover:border-[#e1c47a] hover:bg-[#c9a45c] hover:text-[#080808] sm:bottom-[88px] sm:right-8 sm:h-10 sm:w-10"
        >
          <ArrowUp size={15} strokeWidth={2} />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
